// Import model
import { DataviewProductItemResponse } from '../models/DataviewProductItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterProductItemRequest } from '../models/FilterProductItemRequest';
import { ProductItem } from '../models/ProductItem';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterProductItemRequestSerializer } from './FilterProductItemRequestSerializer';
import { ProductItemSerializer } from './ProductItemSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewProductItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewProductItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewProductItemResponse instance
   */
  static deserialize(json: string): DataviewProductItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewProductItemResponse instance
   */
  static fromObject(obj: any): DataviewProductItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewProductItemResponse');
    }


    const instance: DataviewProductItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ProductItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterProductItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewProductItemResponse instances
   */
  static deserializeArray(json: string): DataviewProductItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewProductItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewProductItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewProductItemResponse instance to a plain object
   */
  static toObject(instance: DataviewProductItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ProductItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterProductItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewProductItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewProductItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
